
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.042 4.629a7.329 7.329 0 00-6.25 11.16l.221.36-1.379 3.217 3.217-1.379.36.22a7.329 7.329 0 0011.16-6.25 7.329 7.329 0 00-7.33-7.328zm-8.958 7.33a8.958 8.958 0 114.645 7.853l-2.453 1.051c-1.352.58-2.718-.787-2.14-2.139l1.052-2.453a8.93 8.93 0 01-1.104-4.313zm4.886-1.63c0-.45.365-.814.814-.814h2.443a.815.815 0 010 1.629H8.784a.815.815 0 01-.814-.815zm0 3.258c0-.45.365-.814.814-.814H15.3a.815.815 0 010 1.628H8.784a.815.815 0 01-.814-.814z"}})])
          )
        }
      }
    